import { Link } from "react-router-dom";
import ScoreDisclaimer from "@/components/ScoreDisclaimer";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-line/10 bg-surface" data-testid="footer">
      <div className="mx-auto max-w-6xl px-5 py-10">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-start sm:justify-between">
          <div className="max-w-md">
            <p className="font-serif text-lg font-bold text-ink">SlantScan</p>
            <p className="mt-2 text-sm leading-relaxed text-faint">
              A side-by-side bias scorer for live news articles. See the slant, read past the framing.
            </p>
          </div>
          {/* Four 20px links stacked 8px apart is a 28px pitch — close enough
              together that a thumb aiming for one lands on its neighbour about
              as often as not. Each row gets a thumb's height on a phone, taken
              out of the gap so the block occupies much the same space, and the
              sm: pair puts the original spacing back. */}
          <div className="flex gap-10 text-sm">
            <div className="flex flex-col gap-0 sm:gap-2">
              <Link to="/" className="flex min-h-11 items-center text-dim hover:text-ink sm:min-h-0">Analyze</Link>
              <Link to="/compare" className="flex min-h-11 items-center text-dim hover:text-ink sm:min-h-0">Compare</Link>
              <Link to="/pricing" className="flex min-h-11 items-center text-dim hover:text-ink sm:min-h-0">Pricing</Link>
              <Link to="/methodology" className="flex min-h-11 items-center text-dim hover:text-ink sm:min-h-0">Methodology</Link>
            </div>
            <div className="flex flex-col gap-0 sm:gap-2">
              <Link to="/terms" className="flex min-h-11 items-center text-dim hover:text-ink sm:min-h-0">Terms</Link>
              <Link to="/privacy" className="flex min-h-11 items-center text-dim hover:text-ink sm:min-h-0">Privacy</Link>
            </div>
          </div>
        </div>
        {/* One copy of this sentence now lives in one file. It was written out
            three times — here, on every report, and on the methodology page —
            which is three places to update and two chances to leave a stale
            version in the build. */}
        <ScoreDisclaimer className="mt-8" testId="footer-score-disclaimer" />
      </div>
    </footer>
  );
}
